import { queryOptions, useQuery } from '@tanstack/react-query'
import { organizationServiceReq } from '@tshared/oapi/req'
import { useUser } from '@tshared/stores/user.store'

const ORG_MANAGE_PATH = '/api/organization/manage/{id}' as const

export function organizationQueryOptions(organizationId: string | undefined) {
  return queryOptions({
    queryKey: [ORG_MANAGE_PATH, organizationId],
    queryFn: async () => {
      const res = await organizationServiceReq.GET(ORG_MANAGE_PATH, {
        params: { path: { id: organizationId ?? '' } },
      })
      return res.data
    },
    staleTime: 1000 * 60 * 60 * 2,
    gcTime: 1000 * 60 * 60 * 24,
    // meta: { persist: true },
  })
}

export function useOrganizationQuery() {
  const organizationId = useUser()?.organization?.id

  return useQuery({
    ...organizationQueryOptions(organizationId),
    enabled: !!organizationId,
  })
}
